import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface StayPhotosMedia {
  id: string;
  day: string;
  time: string;
  description: string;
  mediaKind: "image" | "video";
  url: string;
}

export interface StayPhotosView {
  petName: string;
  periodLabel: string;
  media: StayPhotosMedia[];
}

/** URLs assinadas criadas dentro do runtime local usam `kong:8000`, host que
 * só existe na rede Docker. O navegador deve usar a URL pública do Supabase. */
export function resolveStayMediaUrl(url: string, supabaseUrl: string): string {
  try {
    const signedUrl = new URL(url);
    if (signedUrl.hostname !== "kong") return url;

    const publicUrl = new URL(supabaseUrl);
    signedUrl.protocol = publicUrl.protocol;
    signedUrl.host = publicUrl.host;
    return signedUrl.toString();
  } catch {
    return url;
  }
}

/**
 * A galeria que o responsável abre pelo link do WhatsApp. Roda sem sessão: a
 * edge function valida o token com a service role e devolve URLs assinadas.
 */
export function useStayPhotosView(token: string | undefined) {
  return useQuery({
    queryKey: ["stay-photos-view", token],
    enabled: Boolean(token),
    retry: false,
    queryFn: async (): Promise<StayPhotosView> => {
      const { data, error } = await supabase.functions.invoke("stay-media-share", {
        body: { token },
      });
      if (error) throw error;
      const view = data as StayPhotosView;
      return {
        ...view,
        media: view.media.map((item) => ({
          ...item,
          url: resolveStayMediaUrl(item.url, import.meta.env.VITE_SUPABASE_URL as string),
        })),
      };
    },
  });
}
